import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/projects/components/ProjectsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
